import React from "react";
import { ContextStore } from "../../../../../react-core/Flux/Variables";
import { ContextType } from "../../../../../Wrap/Constants/Enums/ContextType";
import { HierarchyLevelName } from "../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { RoleType } from "../../../../../Wrap/Constants/Enums/RoleType";
import { UserClaim } from "../../../../../Wrap/Constants/Enums/UserClaim";
import { HierarchyIdHelper } from "../../../../Shared/Common/HierarchyIdHelper";
import { checkPermission } from "../../../../Shared/Permission/PermissionHelper";
import { WizardComponent } from "../../../../Shared/Process/WizardComponent";
import { Navigator } from "../../../../Shared/Wizards/Entities/Navigator";
import { getQueryParameters } from "../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Contents } from "../../../Resoures/Contents";
import { Urls } from "../../../Urls";
import { FullClientDetailHelper } from "../Common/FullClientDetail/FullClientDetailHelper";
import { NewBusinessAction } from "../NewBusinessWizard/Actions/NewBusinessAction";
import { AccountInfoAction } from "../PortfolioDashboard/Components/Role/Action/AccountInfoAction";
import { ClientDetails, IClientDetailsState } from "./Components/ClientDetails";
import { InterestedPartySteppers } from "../PortfolioDashboard/Components/Role/Resource/Contents";

export class InterestedPartiesWizard extends WizardComponent {
    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        super.componentDidMount();
        this.setState({ isLoading: false });
    }

    saveInstruction(from: any, to: any, toUrl: any, params: any, stepLength: any) {
        throw new Error("Method not implemented.");
    }
    onCancel() {
        this.onExit();
    }
    onExit() {
        let customerId = getQueryParameters()["customerid"];
        if (!customerId) {
            customerId = this.getCusomterEntityId().entityId;
        }
        Navigator.navigateTo(
            Urls.get().main.PortfolioDashboard({
                hierarchyId: HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Customer, Number(customerId)),
            }).roles,
            {
                scrollAfterNavigating: true,
                queryParamsObject: {},
            }
        );
    }
    private getCusomterEntityId() {
        const customerId = ContextStore.getUrlParamsHierarchyId(ContextType.Customer);
        return HierarchyIdHelper.generateHierarchyId(customerId);
    }
    onSubmit() {
        this.setState({ isSubmitting: true, onPosting: true });
        const state: IClientDetailsState = this.child[0].getState();
        const actorId = getQueryParameters()["ipid"];
        if (Number(actorId) > 0) {
            // update individual info
            NewBusinessAction.saveCCMDetail(Number(actorId), state.customerSelected, (data) => {
                this.onExit();
            });
        } else {
            if (state.roleSelected?.RoleType == RoleType.ControllingPerson) {
                state.customerSelected = FullClientDetailHelper.beforeSave(state.customerSelected);
            }
            if (state.isCreateNewCustomer) {
                // Remove blank space from givenname
                state.customerSelected.PersonalDetails.GivenName = state.customerSelected.PersonalDetails.GivenName.trim();
                // Create new customer and setup new account role
                AccountInfoAction.createInterestedParty(
                    state.roleSelected?.CustomerCategory,
                    state.selectedAccounts.map((x) => x.HierarchyId),
                    state.roleSelected?.RoleType,
                    state.clientPortalAccess || false,
                    state.customerSelected,
                    state.controllingPersonType,
                    (data) => {
                        if (
                            state.clientPortalAccess &&
                            checkPermission(UserClaim.AdviserPortalDluNewUserCanView) &&
                            state.customerSelected.ActorId
                        ) {
                            // direct to create user page
                            window.location.assign(
                                `/admin/users/newuser.aspx?customerid=${state.customerSelected.ActorId}`
                            );
                        } else {
                            // back to accoutn info page
                            this.onExit();
                        }
                    }
                );
            } else {
                state.selectedAccounts.forEach((account) => {
                    // setup new account role
                    AccountInfoAction.updateAccountRole(
                        account.HierarchyId,
                        state.roleSelected?.RoleType,
                        state.clientPortalAccess,
                        state.customerSelected,
                        state.controllingPersonType,
                        (data) => {
                            if (
                                state.clientPortalAccess &&
                                state.customerSelected?.ActorUserId > 0 &&
                                state.roleSelected?.RoleType == RoleType.AccountAccess &&
                                checkPermission(UserClaim.AdviserPortalDluEditUserCanView)
                            ) {
                                // direct to edit user page
                                window.location.assign(
                                    `/Admin/Users/EditUser.aspx?type=edit&searchuserid=${state.customerSelected?.ActorUserId}`
                                );
                            } else if (
                                state.clientPortalAccess &&
                                (state.customerSelected.ActorUserId == 0 ||
                                    (state.customerSelected.ActorUserId == null &&
                                        checkPermission(UserClaim.AdviserPortalDluNewUserCanView)))
                            ) {
                                // direct to create user page
                                window.location.assign(
                                    `/admin/users/newuser.aspx?customerid=${state.customerSelected.ActorId}`
                                );
                            } else {
                                // back to accoutn info page
                                this.onExit();
                            }
                        }
                    );
                });
            }
        }
    }
    setStepperConfig() {
        this.stepperConfig = [
            {
                title: InterestedPartySteppers.clientDetails,
                url: Urls.get().InterestedParties,
                path: Contents.URLMap.clientDetails,
                onSubmit: () => this.onSubmit(),
                canSubmit: () => this.child[0].isValid(),
                component: <ClientDetails {...this.getStepProps(this.stepperConfig.length)} />,
            },
        ];
    }

    setProcessProps() {
        const processProps = super.setProcessProps();
        const actorId = getQueryParameters()["ipid"];
        if (Number(actorId) > 0) {
            processProps.processTitle = "Edit interested party";
        } else {
            processProps.processTitle = "Add interested party";
        }
        processProps.onSave = null;
        return processProps;
    }
}
